import { render, staticRenderFns } from "./user-page.vue?vue&type=template&id=44f58a59"
import script from "./user-page.vue?vue&type=script&lang=js"
export * from "./user-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f58a59')) {
      api.createRecord('44f58a59', component.options)
    } else {
      api.reload('44f58a59', component.options)
    }
    module.hot.accept("./user-page.vue?vue&type=template&id=44f58a59", function () {
      api.rerender('44f58a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Users/user-page.vue"
export default component.exports